import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
require('jquery-ui');
require('jquery-ui/ui/widgets/sortable');
require('jquery-ui/ui/disable-selection');

import { ResponseService } from '../../../../../../services/response.service';
import { RepeatableRandomGeneratorService } from '../../../../../../services/repeatable-random-generator.service';
import { LoggerService } from '../../../../../../services/logger.service';

@Component({
    selector: 'order-interaction',
    template: require('./order-interaction.html'),
})
export class OrderInteractionComponent implements OnInit, AfterViewInit {

    @Input() interaction: PgRendererDto.InteractionDefinition;
    orderInteraction: PgRendererDto.OrderInteraction;
    choices: PgRendererDto.SimpleChoice[];

    constructor(
        private responseService: ResponseService,
        private repeatableRandomGeneratorService: RepeatableRandomGeneratorService,
        private loggerService: LoggerService
    ) {
    }

    ngOnInit() {
        this.orderInteraction = Object.assign({}, this.interaction.OrderInteraction);
        const response = this.responseService.getResponse(this.interaction);
        if (!response) {
            this.choices = this.repeatableRandomGeneratorService.randomizeArray(this.orderInteraction.SimpleChoices);
        } else {
            this.choices = [];
            response.Items.forEach(r => {
                const choice = this.orderInteraction.SimpleChoices.find(c => c.Identifier == r.Value);
                this.choices.push({
                    Identifier: choice.Identifier,
                    Html: choice.Html,
                    ChoiceDisplayOrder: null
                });
            });
        }
    }

    ngAfterViewInit() {
        try {
            const jqOrderInteraction = $(`#order-interaction-${this.interaction.InteractionId}`);
            jqOrderInteraction.sortable();
            jqOrderInteraction.disableSelection();
            jqOrderInteraction.on("sortstop", (event: JQueryEventObject) => {
                this.responseService.clearInteractionResponses(this.interaction.InteractionId);
                $(event.target).find("li").each((index, element: HTMLElement) => {
                    this.responseService.setResponse(this.interaction, null, element.id, null, this.choices.length > 1, null);
                });
            });
        } catch (error) {
            this.loggerService.reportFatalError("OrderInteractionComponent", error);
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/order-interaction/order-interaction.component.ts